import * as React from 'react'
import { withStyles, WithStyles } from '@zn-material-ui'
import { renderRoutes } from 'react-router-config'
import { withSnackbar, withSnackbarProps } from 'notistack'
import { observer, inject } from 'mobx-react'
import classnames from 'classnames'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import Store from 'store'
import homeStyles from './styles/HomeStyle'
import { RouteComponentProps } from 'react-router'
import AppBar from '../../components/AppBar'
import Tabs from '@components/Tabs'
import { IRouteInterface } from '@src/routes/interface'
import { IUserStore } from '@stores/UserStore'
import { IHomeStore } from '@stores/Home'
import { routeDetail, isCourse } from './constant'

enum RouteMapEnum {
  'HOME' = '/home/homePage',
  'COURSE' = '/home/course', // 资源中心的路由
  'VIDEO' = '/home/liteVideo', // 短视频的路由
  'LIVE' = '/home/livelist/1', // 直播的路由
  'EXAM' = '/home/publicExam', // 学考中心的路由
  'TRAIN' = '/home/trainingClass', // 培训中心的路由
  'INFO' = '/home/inforList', // 资讯中心的路由
  'KNOWLEDGE' = '/home/KnowledgeLib', // 文库
  'PROFESSOR' = '/home/trainerCenter', // 教官中心的路由
  'PERSONAL' = '/home/personalCenter', // 个人中心的路由
  'IKNOW' = '/home/communicateCenter', // 知圈的路由
  'CLOUDTRAINING' = '/home/openTrainingProjectList', // 云校我的培训项目
  'KNOWLEDGECLOUD' = '/znWeb/knowledge-cloud/#/home', // 知识云,
  'QUALIFY_EXAM' = '/home/examLibrary/' // 题库
}
export interface IProps
  extends WithStyles<typeof homeStyles>,
    withSnackbarProps,
    RouteComponentProps {
  route: IRouteInterface
  UserStore: IUserStore
  HomeState: IHomeStore
}

export interface IState {
  currentTab: string
}

@inject('UserStore', 'HomeState')
@observer
class Home extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      currentTab: Store.get('currentTab') || 'HOME',
    }
  }

  public async componentDidMount() {
    const { HomeState, UserStore } = this.props
    const moduleList = await HomeState.queryHomeChannelModule(UserStore.homeId)
    const homeModule = moduleList.find(
      v => v.channelModuleType === this.state.currentTab
    )

    if (!homeModule && moduleList[0]) {
      // 首页频道不存在的情况下处理成频道列表第1个
      const currentTab = moduleList[0].channelModuleType

      if (currentTab) {
        Store.set('currentTab', currentTab)
        this.props.history.push(RouteMapEnum[currentTab])
        return
      }
    }
  }

  public componentWillReceiveProps(nextProps: IProps) {
    if (!_.isEqual(this.props, nextProps)) {
      this.resetTab(nextProps)
    }
  }

  public componentDidUpdate(nextProps: IProps) {
    this.resetTab(nextProps)
  }

  private resetTab = (data: IProps) => {
    const path = data.location.pathname
    const list = data.HomeState.moduleList || []
    const currentTab = this.state.currentTab
    if (path !== RouteMapEnum[currentTab]) {
      const tab = list.find(v => RouteMapEnum[v.channelModuleType] === path)
      if (tab) {
        Store.set('currentTab', tab.channelModuleType)
        this.setState({ currentTab: tab.channelModuleType })
      }
    }
  }

  public render() {
    const { classes, route, HomeState } = this.props
    const allTabs =
      HomeState.moduleList.map(v => ({
        label: v.channelModuleName,
        key: v.channelModuleType,
      })) || []
    const { pathname } = this.props.location
    const isCourseDetail = () => {
      let result = false
      isCourse.forEach(v => {
        if (pathname.includes(v)) {
          result = true
        }
      })
      return result
    }
    const isTabs = () => {
      let result = true
      routeDetail.forEach(v => {
        if (pathname.includes(v)) {
          result = false
        }
      })
      return result
    }
    const marginTop = (allTabs.length && isTabs() && '114px') || '64px'
    const routes = HomeState.filterRoute(route.children || []) || route.children
    const hasOrg = Store.get('hasOrg') || false
    return (
      <div className={classnames(classes.home)}>
        <AppBar />
        {isTabs() && hasOrg && (
          <div className={classes.fixedTab}>
            {(allTabs.length && (
              <Tabs
                tabs={allTabs}
                onTabChange={this.onTabChange}
                defaultValue={this.state.currentTab}
                classes={{
                  root: classes.root,
                  flexContainer: classes.flexContainer,
                }}
                align="flex-center"
              />
            )) ||
              null}
          </div>
        )}
        <div
          className={`${classes.routeChildrenWrap} ${
            isCourseDetail() ? classes.notTabs : ''
          }`}
          style={HomeState.style}
        >
          <div
            style={{
              marginTop,
              ...(HomeState.childrenStyle || {}),
            }}
            className={classes.childContentWrap}
          >
            {renderRoutes(routes)}
          </div>
        </div>
      </div>
    )
  }
  private onTabChange = (currentTab: string) => {
    this.setState({ currentTab })
    Store.set('currentTab', currentTab)
    const url = RouteMapEnum[currentTab]
    if (url.includes('#')) {
      window.open(`${window.location.origin}${url}`)
    } else {
      this.props.history.push(url)
    }
  }
}

export default withStyles(homeStyles)(withSnackbar(withRouter(Home)))
